
export const IconUploadImage = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 14 11" fill="none">
            <path d="M7.5 11V8H9.5L7 5L4.5 8H6.5V11H4V10.975C3.916 10.98 3.836 11 3.75 11C2.75544 11 1.80161 10.6049 1.09835 9.90165C0.395088 9.19839 0 8.24456 0 7.25C0 5.326 1.455 3.758 3.322 3.543C3.48569 2.68729 3.94244 1.91537 4.61371 1.36C5.28497 0.804629 6.12878 0.500528 7 0.5C7.87134 0.500488 8.71529 0.804553 9.38672 1.35991C10.0581 1.91527 10.5151 2.68721 10.679 3.543C12.546 3.758 13.999 5.326 13.999 7.25C13.999 8.24456 13.6039 9.19839 12.9006 9.90165C12.1974 10.6049 11.2436 11 10.249 11C10.165 11 10.084 10.98 9.999 10.975V11H7.5Z" fill={props?.fill}/>
        </svg>

    )
}
